import { render, staticRenderFns } from "./MobileBar.vue?vue&type=template&id=e473e96e&"
import script from "./MobileBar.vue?vue&type=script&lang=js&"
export * from "./MobileBar.vue?vue&type=script&lang=js&"
import style0 from "./MobileBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBottomNavigation,VBtn,VIcon,VSnackbar})
